import { css } from '@emotion/react';

export default css({
  '&.account-home': {
    flexDirection: 'column',
  },
});
